import * as Sentry from '@sentry/browser';
export class HttpRequestService {
    static async request(url, options) {
        const response = await fetch(url, options);
        if (!response.ok && response.status !== 404) {
            console.log(`HTTP error! status: ${response.status}`);
            await logSentryDetails(response, options.body);
        }
        return response;
    }
    static async getRequest(url, queryParams = {}) {
        return await this.request(createUrlWithParams(url, queryParams), {});
    }
    static async postJson(url, data) {
        return await this.request(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data),
        });
    }
    static async postSerializedData(url, serializedData) {
        return await this.request(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: serializedData
        });
    }
    static async postFormData(url, data) {
        return await this.request(url, {
            method: 'POST',
            body: data
        });
    }
    static async delete(url, data) {
        return await this.request(url, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data),
        });
    }
}
export function createUrlWithParams(url, data) {
    const urlObject = new URL(url, window.location.origin);
    urlObject.search = new URLSearchParams(data).toString();
    return urlObject.href;
}
async function logSentryDetails(response, requestPayload) {
    if (!response) {
        return;
    }
    let responseBody;
    let parsedJson = null;
    const clone = response.clone();
    try {
        responseBody = await clone.text();
    }
    catch {
        responseBody = '';
    }
    if (responseBody) {
        try {
            parsedJson = JSON.parse(responseBody);
        }
        catch {
            parsedJson = null;
        }
    }
    const correlationId = response.headers.get('correlation-id');
    if (correlationId) {
        Sentry.setTag('correlation-id', correlationId);
    }
    Sentry.captureException(new Error('Frontend error'), {
        extra: {
            status: response.status,
            statusText: response.statusText,
            url: response.url,
            contentType: response.headers.get('content-type'),
            contentLength: response.headers.get('content-length'),
            hasBody: responseBody.length > 0,
            responseBody: responseBody || '[empty]',
            responseJson: parsedJson,
            requestPayload,
            correlationId: correlationId || '[not provided]'
        }
    });
}
